import React from "react";
import { FinancialDocument } from "@common/types/financialDocument";
import { FinancialDocumentPreview } from "@components/documents/FinancialDocumentDetails/FinancialDocumentPreview";
import nativeInvoiceStyles from "@components/invoices/NativeInvoiceDrawer/NativeInvoiceDrawer.module.scss";
import { AccrualDraftAttachedFilePreview } from "./AccrualDraftAttachedFilePreview";

const NO_RETRY = { retry: false };

interface Props {
    financialDocument: Pick<FinancialDocument, "id" | "fileName">;
}

export const AccrualCounterpartyFilePreview: React.FC<Props> = ({
    financialDocument,
}) => (
    <div className={nativeInvoiceStyles.previewPane}>
        <AccrualDraftAttachedFilePreview
            financialDocument={financialDocument}
            fallback={
                <FinancialDocumentPreview
                    financialDocument={financialDocument}
                    queryOptions={NO_RETRY}
                />
            }
        />
    </div>
);
